import { useNavigate } from 'react-router-dom';
import { useMemo, useState } from 'react';
import { TableColumn } from '../../components/DataTable/TableColumn';
import { TextColumn } from '../../components/DataTable/TextColumn';
import { DateColumn } from '../../components/DataTable/DateColumn';
import { Slider } from '../../interfaces/Slider/Slider';
import { paginateRows } from '../../utils/Pagination';
import { DataTable } from '../../components/DataTable/DataTable';

const columns: TableColumn<Slider>[] = [
  {
    id: 'id',
    name: 'ID',
    accessor: (row) => <TextColumn value={row.id.toString()} />,
  },
  {
    id: 'name',
    name: 'İsim',
    accessor: (row) => <TextColumn value={row.name} />,
  },
  {
    id: 'created-at',
    name: 'Oluşturulma Tarihi',
    accessor: (row) => <DateColumn value={row.createdAt} />,
  },
  {
    id: 'updated-at',
    name: 'Düzenlenme Tarihi',
    accessor: (row) => <DateColumn value={row.updatedAt} />,
  },
];

type SlidersTableProps = {
  sliders: Slider[];
};

export const SlidersTable = (props: SlidersTableProps) => {
  const navigate = useNavigate();

  const [page, setPage] = useState(0);
  const [limit, setLimit] = useState(10);

  const paginatedRows = useMemo(
    () => paginateRows(props.sliders, limit, page),
    [props.sliders, limit, page],
  );

  return (
    <DataTable
      columns={columns}
      totalCount={props.sliders.length}
      rows={paginatedRows}
      limit={limit}
      setLimit={setLimit}
      page={page}
      setPage={setPage}
      onClick={(slider) => navigate(`/visual/sliders/${slider.id}`)}
    />
  );
};
